<template>
    <div style="width: 100%;margin: 10px 0;">
        <!-- 用el-table实现上面的表格 -->
        <div v-if="group.contentType==1||group.datasetType==1">
            <div v-if="config.showFilter">
                <el-input v-model="searchKey" clearable style="width: 270px;margin: 5px 0px;"
                          placeholder="请输入关键字">
                    <el-button slot="append" class="el-icon-search" @click="doSearch"></el-button>
                </el-input>
            </div>
            <el-table v-show="renderOk" :data="tableList" ref="reftables" v-loading="loading" border stripe fit
                      style="width: 100%">
                <el-table-column type="index" label="序号" align="center" header-align="center" width="80px"
                                 v-if="config.showSort==1"/>
                <el-table-column v-for="(item,index) in columns"
                                 v-if="!config.toChild||config.toChild&&item.columnType!='1'"
                                 :key="(group.id || group.groupId) + index"
                                 :label="item.displayName" :prop="item.columnName"
                                 :width="item.columnWidth?item.columnWidth:'auto'">
                    <template slot-scope="scope">
                        <template v-if="item.childs">
                            <el-table-column v-for="(child,childIndex) in item.childs"
                                             :key="child.id+childIndex"
                                             :label="child.displayName"
                                             :prop="child.columnName"
                                             :width="child.columnWidth?child.columnWidth:'auto'">
                                <template #default="scope">
                                    <dialog-open-btn-item
                                        v-if="config.showOpt && child.columnType==='1' && scope.row[child.columnName]"
                                        :context="scope.row" :parent-id="scope.row[child.columnName]"
                                        :param-map="paramMap" :config="parseSource(child.datasource)"/>
                                    <attachment-list-item
                                        v-else-if="config.showOpt && child.columnType==='8' && scope.row[child.columnName]"
                                        :parent-id="scope.row[child.columnName]"
                                        :param-map="paramMap"
                                        :config="parseSource(child.datasource)" :render-to-btn="true"/>
                                    <span v-else>{{ scope.row[child.columnName] }}</span>
                                </template>
                            </el-table-column>
                        </template>
                        <template v-else>
                            <dialog-open-btn-item v-if="config.showOpt&&item.columnType=='1'&&scope.row[item.columnName]"
                                                  :context="scope.row" :parent-id="scope.row[item.columnName]"
                                                  :param-map="paramMap" :config="parseSource(item.datasource)"/>
                            <attachment-list-item v-else-if="config.showOpt && item.columnType=='8' && scope.row[item.columnName]"
                                                  :parent-id="scope.row[item.columnName]"
                                                  :param-map="paramMap"
                                                  :config="parseSource(item.datasource)" :render-to-btn="true"/>
                            <span v-else :style="scope.row[item.style]">{{ scope.row[item.columnName] }}</span>
                        </template>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination v-if="config.showPage"
                           background
                           @size-change="sizeChangeHandle"
                           @current-change="currentChangeHandle"
                           :current-page="pageIndex"
                           :page-sizes="[10, 20, 50, 100]"
                           :page-size="pageSize"
                           :total="total"
                           layout="total, sizes, prev, pager, next, jumper"
                           style="margin-top: 12px; float: right"
            ></el-pagination>
        </div>

        <el-form v-else-if="group.contentType==0"
                 label-width="200px" style="display: flex;flex-wrap: wrap;justify-content: space-between">
            <el-form-item v-for="(cellItem,i) in group.dataList" v-if="cellItem.showInList"
                          :key="i"
                          :label-width="cellItem.textType === 0?'0px':'200px'"
                          :class="{
                                    'single-row':(cellItem.columnCount == '1' || cellItem.columnType  == '3' ),
                                    'double-row':(cellItem.columnCount == '2' && cellItem.columnType  != '3' ),
                                    'third-row':(cellItem.columnCount == '3' && cellItem.columnType  != '3'),
                                    }">
                <template slot="label" v-if="cellItem.textType === 1">
                    <span style="display:inline-block;width:174px">{{ cellItem.title }}</span>
                    <span style="display:inline-block;vertical-align: top;">：</span>
                </template>
                <div v-if="cellItem.columnType == '3'" v-html="cellItem.value" style="text-align: left"></div>

                <warn-record-item v-else
                                  :data="cellItem"
                                  :form-info="formInfo"
                />
            </el-form-item>
        </el-form>

        <div v-else-if="!renderOk" class="loading_class">
            数据渲染中...
        </div>

    </div>
</template>

<script>
import warnRecordItem from "./WarnRecordItem";
import dialogOpenBtnItem from "./DialogOpenBtnItem";
import attachmentListItem from "./AttachmentListItem";
import {
    apiCustomformQueryDetail,
    apiCustomformQueryList,
    apiCustomformQueryListcols
} from "../../server/formRender";

export default {
    components: {
        warnRecordItem,
        dialogOpenBtnItem,
        attachmentListItem,
    },
    name: "customSubItem",
    props: {
        parentId: {
            type: String,
            required: true
        },
        paramMap: {
            type: Object,
            required: true
        },
        context: {
            type: Object,
            default: function () {
                return {}
            }
        },
        config: {
            type: Object,
            required: true,
            default: function () {
                return {showSort: 1, formId: '', showPage: false, showFilter: false, showOpt: false, toChild: false}
            },
        }
    },
    data() {
        return {
            formInfo: {},
            group: {},
            formId: this.config.formId,
            pageSize: 10,//每页条数
            pageIndex: 1,//当前页
            total: 0,//总条数
            searchKey: "",
            loading: false,
            columns: [],
            tableList: [],
            filterMap: {},
            renderOk: false,
        }
    },
    created() {
        this.filterMap = {...this.paramMap}
        this.filterMap["entityId"] = this.parentId
        if (this.config.showPage || this.config.showFilter || this.config.showOpt) {
            this.getTableColumns()
        }else {
            this.getCustomData(this.formId)
        }
    },
    mounted() {

    },
    methods: {
        async getCustomData(formId) {
            this.customformQueryDetail(formId)
        },
        customformQueryDetail(formId) {
            // formId=自定义表单id ,paramMap= 项目数据参数 ，getAttByEntityId = 是否通过查询 entityId 和 已传参数categoryCode 查询附件数据及监督记录数据，detailId =  招标文件澄清与修改及资审文件澄清与修改 查看详情数据的id
            this.formId = formId;
            // 重新定义查询参数，避免污染全局 paramMap 对象
            let paramsMapTemp = JSON.parse(JSON.stringify(this.filterMap))
            if (formId) {
                apiCustomformQueryDetail(formId, paramsMapTemp).then(({data}) => {
                    if (JSON.stringify(data) != "{}") {
                        this.group = data.data && data.data.length > 0 ? data.data[0] : {};
                        if (this.group.contentType == 1) {
                            this.columns = this.group.fieldList || [];
                            this.tableList = this.group.rowList || [];
                        }
                        this.formInfo = data.form;
                    } else {
                        this.group = {};
                        this.formInfo = {}
                    }
                }).finally(() => {
                    this.renderOk = true
                })
            } else {
                this.group = {};
                this.formInfo = {};
                this.renderOk = true
            }
        },

        doSearch() {
            this.pageIndex = 0
            this.total = 0
            this.getDataList();
        },

        getTableColumns() {
            if (!this.formId) {
                return
            }
            this.getDataList(() => {
                apiCustomformQueryListcols(this.formId).then(res => {
                    var data = res.data
                    this.columns = data.columns || [];
                    console.log(this.columns)
                    this.group = data.group || {};
                    this.renderOk = true
                })
            })

        },
        getDataList(callback) { // 获取列表数据
            this.loading = true;
            if (!this.formId) {
                return
            }
            var filters = {...this.filterMap};
            const params = {
                'page': this.pageIndex,
                'rows': this.pageSize,
                searchKey: this.searchKey,
                'filter': filters,
                total: this.total,
            }
            apiCustomformQueryList(this.formId, params).then(res => {
                this.tableList = res.data.rows;
                console.log(this.tableList)
                this.total = res.data.total;
                if (callback && typeof callback == "function") {
                    callback();
                }
                this.loading = false;
            }).catch(e => {
                console.error("请求错误：", e)
                this.loading = false;
            })
        },

        sizeChangeHandle(val) {
            this.pageSize = val;
            this.pageIndex = 1
            this.getDataList()
        },
        currentChangeHandle(val) {
            this.pageIndex = val
            this.getDataList()

        },
        parseSource(src) {
            return src ? JSON.parse(src) : {};
        }
    }
}
</script>

<style scoped lang="less">
.loading_class {
    width: 100%;
    display: block;
    text-align: center;
    vertical-align: middle;
    font-weight: bolder;
    font-size: 20px;
}
</style>
